
import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { FiltroPersonamast } from '../../dominio/FiltroPersonamast';
import { PersonamastServicio } from '../../service/personamast.service';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { DtoPersonamast } from '../../dominio/DtoPersonamast';
import { Router, ActivatedRoute } from '@angular/router';
import { CanvasComponent } from 'src/app/util/canvas.component';
import { UsuarioPublicService, DtoDocumentoFirmar } from 'src/app/seguridad/seguridad/usuario.public.service';
import { LineaCreditoComponent } from '../../../clientemast/vista/linea-credito/linea-credito.component';
import { Table } from 'primeng/table';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    templateUrl: './cliente-listado.component.html'
})
export class ClienteListadoComponent extends PrincipalBaseComponent implements OnInit {
    verFirmar: boolean = false;
    testFirma: boolean = false;
    @ViewChild(CanvasComponent, { static: false }) canvasComponent: CanvasComponent;

    @ViewChild(Table, { static: false }) dataTableComponent: Table;
    checked: boolean = true;
    noChecked: boolean = false;
    cargando: boolean = true;
    tipo: String = '';
    seleccionado: DtoPersonamast;

    filtroInit: FiltroPersonamast = new FiltroPersonamast();
    filtro: FiltroPersonamast = new FiltroPersonamast();
    registrosPorPagina: number = 20;

    listaClientes: DtoPersonamast[] = [];

    constructor(
        private cdref: ChangeDetectorRef,
        private usuarioPublicService: UsuarioPublicService,
        private router: Router,
        private route: ActivatedRoute,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        private personamastServicio: PersonamastServicio) { super(noAuthorizationInterceptor, messageService); }

    ngOnInit() {
        super.ngOnInit();
        this.bloquearPagina();
        this.tipo = this.route.snapshot.params['tipo'] as string;

        if (this.route.snapshot.params['filtro'] !== undefined) {
            const filtro = this.route.snapshot.params['filtro'];
            this.filtroInit = JSON.parse(filtro) as FiltroPersonamast;
        }

        if (this.filtroInit != null) {
            this.filtro = this.filtroInit;
        }
        this.buscar();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }


    onClick(event: any, row: any) {
        const slides = Array.from(document.getElementsByClassName('j_sDuo'));

        for (const x of slides) {
            const y = <HTMLElement>x;
            y.style.display = 'none';
        }
    }

    buscar() {
        sessionStorage.setItem('filtrosCliente', 'LIMPIAR');
        this.personamastServicio.listarClientesPorVendedor(this.filtro).then(
            resp => {
                this.listaClientes = resp;
                this.desbloquearPagina();
            }
        )
    }

    cargarPaginacion(event: LazyLoadEvent) {

        if (this.cargando) {
            this.cargando = false;
            return;
        }

        const ss = sessionStorage.getItem('filtrosCliente');
        if (ss !== undefined && ss !== null && ss !== 'LIMPIAR') {
            const prefiltro = JSON.parse(ss) as FiltroPersonamast;
            this.filtro = prefiltro;
        }

        this.filtro.buscarDentro = 'true';
        this.filtro.conInactivos = 'true';

        this.bloquearPagina();
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;

        sessionStorage.setItem('filtrosCliente', JSON.stringify(this.filtro));

        this.personamastServicio.listarPaginacionCliente(this.filtro)
            .then(pg => {
                this.seleccionado = null;
                this.filtro.paginacion = pg;
                this.desbloquearPagina();
            });
    }

    nuevaCotizacion() {
        if (this.seleccionado == null) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente');
            return;
        }
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'NUEVO', JSON.stringify(this.seleccionado)], { skipLocationChange: true });
    }

    nuevoPedido() {
        if (this.seleccionado == null) {
            this.mostrarMensajeAdvertencia('Seleccionar un cliente');
            return;
        }
        if (this.seleccionado.suspensionFlag === 'S') {
            this.mostrarMensajeAdvertencia('El Cliente está suspendido');
            return;
        }
        this.router.navigate(['/royal/pedido-mantenimiento', 'NUEVO', JSON.stringify(this.seleccionado)], { skipLocationChange: true });
    }

    verDocsXCobrar(bean: DtoPersonamast) {
        this.router.navigate(['/royal/codocumentocobrar-listado', JSON.stringify(bean), 'VERCLIENTE', JSON.stringify(this.filtro)], { skipLocationChange: true });
    }

    verLineaCredito(bean: DtoPersonamast) {
        this.router.navigate(['/royal/linea-credito', JSON.stringify(bean), JSON.stringify(this.filtro)], { skipLocationChange: true });
    }

    verLetras(bean: DtoPersonamast) {
        this.router.navigate(['/royal/letra-listado', JSON.stringify(bean), JSON.stringify(this.filtro)], { skipLocationChange: true });
    }
    abrirDialogoFirmar() {
        this.verFirmar = true;
    }
    guardarFirma() {
        var canvas = this.canvasComponent.canvas.nativeElement;

        //modificar un pdf, aun no se hace

        // abrir para que seleccione un pdf

        // abrir la vista previa del pdf

        // colocar la imagen de la firma para que indique el lugar

        // generar pdf con firma incluida

        // const doc = new jsPDF();
        const base64 = canvas.toDataURL("image/png");
        const base64ImgString = base64.split(',')[1];
        // doc.addImage(base64ImgString, 15, 15, 80, 26);
        // doc.save("FIRMADO" + '_' + Math.random().toString(36).substr(2, 9));

        // FLUJO PRACTICO -------------> GENERAR BOLETA

        // LUEGO DE GENERAR LA IMAGEN, ENVIAR AL REST EL BASE64(base64)

        // EN LUGAR DE BUSCAR LA FIRMA EN SY_ReporteArchivo, SE TOMA LA FIRMA GENERADA
    }
    cerrarDialogoFirma() {
        this.verFirmar = false;
    }

    cargarFoto(event: any) {
        this.bloquearPagina();

        var files = event.files;

        var filePath = files[0].name;

        var reader = new FileReader();
        reader.readAsDataURL(files[0]);

        reader.onloadend = (evt) => {
            var result = reader.result;

            var canvas = this.canvasComponent.canvas.nativeElement;

            var dto: DtoDocumentoFirmar = new DtoDocumentoFirmar();
            dto.pdfBase64 = result as string;
            dto.imagenBase64 = canvas.toDataURL("image/png");

            this.usuarioPublicService.firmarDocumento(dto).then(
                x => {
                    const a = document.createElement('a');
                    a.href = 'data:image/png;base64,' + x.resultadoBase64;

                    a.setAttribute('download', "filegenerate.pdf");
                    const b = document.createEvent('MouseEvents');
                    b.initEvent('click', false, true);
                    a.dispatchEvent(b);
                }
            );


            this.desbloquearPagina();
        };
    }

}
